export default ({ store }) => {
  store.dispatch('syncStates')
}
